import { FiCheck, FiStar } from "react-icons/fi";
import PlanAction from "./PlanAction";
import { count, displayCount, isInstitutionPlan, picksPolicy, planDuration, planPrice } from "./subscriptionDetails";

export default function PlanCard({ plan, activePlan, currency, statusUnavailable }) {
	const institutional = isInstitutionPlan(plan);
	const current = activePlan && String(activePlan.id) === String(plan.id);
	const price = planPrice(plan, currency);
	const duration = planDuration(plan);
	const credits = count(plan.credits);
	const allocations = displayCount(plan.max_allocations_per_seat ?? plan.max_number_of_books);
	const features = institutional ? [
		`${allocations} book allocations per student`,
		picksPolicy(plan) === "unlimited" ? "Unlimited institution picks bank" : `${displayCount(plan.max_number_of_books)} premium picks`,
		"Read in the Akello Library app",
	] : [
		`${displayCount(plan.max_number_of_books)} premium book picks`,
		"Unlimited free titles",
		"Offline reading in the app",
	];
	return (
		<article className={"plans-card" + (current ? " plans-card-current" : "")} aria-labelledby={`plan-${plan.id}-heading`}>
			<div className="plans-card-top"><span className="plans-category">{institutional ? "Institution" : "Individual"}</span>{current && <span className="plans-current-label"><FiCheck aria-hidden="true" />Current plan</span>}</div>
			<h3 id={`plan-${plan.id}-heading`}>{plan.name}</h3>
			<p className="plans-duration">{duration ? `${duration} of reading access` : "Reading access"}</p>
			<div className="plans-price-block"><p className={"plans-price" + (price === null ? " plans-price-unavailable" : "")}>{price ?? "Price unavailable"}</p><p>{institutional ? "per seat · " : ""}{duration ? `for ${duration}` : "Duration shown at checkout"}</p>{credits > 0 && <p className="plans-stars"><FiStar aria-hidden="true" />or {credits.toLocaleString()} stars{institutional ? " per seat" : ""}</p>}</div>
			<ul className="plans-features">{features.map((feature) => <li key={feature}><FiCheck aria-hidden="true" /><span>{feature}</span></li>)}</ul>
			{institutional && <p className="plans-seat-note">Choose the number of seats at checkout. Total = price per seat × seats.</p>}
			<div className="plans-card-action"><PlanAction plan={plan} activePlan={activePlan} currency={currency} statusUnavailable={statusUnavailable} /></div>
		</article>
	);
}
